import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import * as nls from '../../../nls.js';
import { Disposable } from '../../../base/common/lifecycle.js';
import { IInstantiationService } from '../../../platform/instantiation/common/instantiation.js';
import { EditorContextKeys } from '../../common/editorContextKeys.js';
import { ContextKeyExpr } from '../../../platform/contextkey/common/contextkey.js';
import { registerEditorAction, registerEditorContribution, EditorAction, EditorCommand, registerEditorCommand } from '../../browser/editorExtensions.js';
import { ParameterHintsWidget } from './parameterHintsWidget.js';
import { Context } from './provideSignatureHelp.js';
import * as modes from '../../common/modes.js';

var ParameterHintsController = /*#__PURE__*/function (_Disposable) {
  _inherits(ParameterHintsController, _Disposable);

  var _super = _createSuper(ParameterHintsController);

  function ParameterHintsController(editor, instantiationService) {
    var _this;

    _classCallCheck(this, ParameterHintsController);

    _this = _super.call(this);
    _this.editor = editor;
    _this.widget = _this._register(instantiationService.createInstance(ParameterHintsWidget, _this.editor));
    return _this;
  }

  _createClass(ParameterHintsController, [{
    key: "cancel",
    value: function cancel() {
      this.widget.cancel();
    }
  }, {
    key: "previous",
    value: function previous() {
      this.widget.previous();
    }
  }, {
    key: "next",
    value: function next() {
      this.widget.next();
    }
  }, {
    key: "trigger",
    value: function trigger(context) {
      this.widget.trigger(context);
    }
  }], [{
    key: "get",
    value: function get(editor) {
      return editor.getContribution(ParameterHintsController.ID);
    }
  }]);

  return ParameterHintsController;
}(Disposable);

ParameterHintsController.ID = 'editor.controller.parameterHints';
ParameterHintsController = __decorate([__param(1, IInstantiationService)], ParameterHintsController);
export var TriggerParameterHintsAction = /*#__PURE__*/function (_EditorAction) {
  _inherits(TriggerParameterHintsAction, _EditorAction);

  var _super2 = _createSuper(TriggerParameterHintsAction);

  function TriggerParameterHintsAction() {
    _classCallCheck(this, TriggerParameterHintsAction);

    return _super2.call(this, {
      id: 'editor.action.triggerParameterHints',
      label: nls.localize('parameterHints.trigger.label', "Trigger Parameter Hints"),
      alias: 'Trigger Parameter Hints',
      precondition: EditorContextKeys.hasSignatureHelpProvider,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: 2048
        /* CtrlCmd */
        | 1024
        /* Shift */
        | 10
        /* Space */
        ,
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(TriggerParameterHintsAction, [{
    key: "run",
    value: function run(accessor, editor) {
      var controller = ParameterHintsController.get(editor);

      if (controller) {
        controller.trigger({
          triggerKind: modes.SignatureHelpTriggerKind.Invoke
        });
      }
    }
  }]);

  return TriggerParameterHintsAction;
}(EditorAction);
registerEditorContribution(ParameterHintsController.ID, ParameterHintsController);
registerEditorAction(TriggerParameterHintsAction);
var weight = 100
/* EditorContrib */
+ 75;
var ParameterHintsCommand = EditorCommand.bindToContribution(ParameterHintsController.get);
registerEditorCommand(new ParameterHintsCommand({
  id: 'closeParameterHints',
  precondition: Context.Visible,
  handler: function handler(x) {
    return x.cancel();
  },
  kbOpts: {
    weight: weight,
    kbExpr: EditorContextKeys.focus,
    primary: 9
    /* Escape */
    ,
    secondary: [1024
    /* Shift */
    | 9
    /* Escape */
    ]
  }
}));
registerEditorCommand(new ParameterHintsCommand({
  id: 'showPrevParameterHint',
  precondition: ContextKeyExpr.and(Context.Visible, Context.MultipleSignatures),
  handler: function handler(x) {
    return x.previous();
  },
  kbOpts: {
    weight: weight,
    kbExpr: EditorContextKeys.focus,
    primary: 16
    /* UpArrow */
    ,
    secondary: [512
    /* Alt */
    | 16
    /* UpArrow */
    ],
    mac: {
      primary: 16
      /* UpArrow */
      ,
      secondary: [512
      /* Alt */
      | 16
      /* UpArrow */
      , 256
      /* WinCtrl */
      | 46
      /* KEY_P */
      ]
    }
  }
}));
registerEditorCommand(new ParameterHintsCommand({
  id: 'showNextParameterHint',
  precondition: ContextKeyExpr.and(Context.Visible, Context.MultipleSignatures),
  handler: function handler(x) {
    return x.next();
  },
  kbOpts: {
    weight: weight,
    kbExpr: EditorContextKeys.focus,
    primary: 18
    /* DownArrow */
    ,
    secondary: [512
    /* Alt */
    | 18
    /* DownArrow */
    ],
    mac: {
      primary: 18
      /* DownArrow */
      ,
      secondary: [512
      /* Alt */
      | 18
      /* DownArrow */
      , 256
      /* WinCtrl */
      | 44
      /* KEY_N */
      ]
    }
  }
}));